<template>
  <v-btn icon flat small @click="goRoute">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
      <span>Ver comunicación</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goRoute () {
      this.$router.push({ name: 'detalleBoletin', params: { id: this.item.id } })
    }
  }
}
</script>
